import React, { useState } from 'react';
import { auth, db } from '../firebase';
import {
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    updateProfile
} from 'firebase/auth';
import { ref, set, get } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { FaUser, FaLock, FaEnvelope, FaChevronDown, FaUserPlus, FaSignInAlt, FaExclamationTriangle } from 'react-icons/fa';
import slider3 from './Asstes/slider3.jpeg';
import sangliLogo from './Asstes/sanglizp.png';

const Login = () => {
    const [isRegistering, setIsRegistering] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        name: '',
        userId: '', // Single field for Email/Username/Mobile
        password: '',
        role: ''
    });

    const roles = [
        "User",
        "Incharge",
        "Accountant",
        "Engineer",
        "Admin",
        "CEO",
        "ZP Head",
        "Audit"
    ];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };



    const handleRegister = async (e) => {
        e.preventDefault();
        if (!formData.role) {
            toast.error("कृपया पद निवडा (Please select a role)");
            return;
        }
        setLoading(true);
        try {
            const userCredential = await createUserWithEmailAndPassword(auth, formData.userId, formData.password);
            const user = userCredential.user;

            await updateProfile(user, { displayName: formData.name });

            // Save user details with role in Realtime Database under ekamwatapzp node
            await set(ref(db, 'ekamwatapzp/users/' + formData.name), {
                name: formData.name,
                email: user.email,
                role: formData.role,
                password: formData.password,
                createdAt: new Date().toISOString()
            });

            toast.success("नोंदणी यशस्वी झाली! (Registration Successful!)");
            let dashboardRoute = `/${formData.role.toLowerCase()}-dashboard`;
            if (formData.role === 'Admin') dashboardRoute = '/admin-dashboard';
            if (formData.role === 'CEO') dashboardRoute = '/ceo-dashboard';
            if (formData.role === 'ZP Head') dashboardRoute = '/zp-head';
            if (formData.role === 'Audit') dashboardRoute = '/audit/dashboard';
            if (formData.role === 'Accountant') dashboardRoute = '/accountant-dashboard';
            if (formData.role === 'Incharge') dashboardRoute = '/incharge-dashboard';
            if (formData.role === 'User') dashboardRoute = '/subhe-dashboard';
            
            navigate(dashboardRoute);
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    const checkRegistries = async () => {
        const registryNodes = ['ekamwatapzp/EngineerRegistrations', 'ekamwatapzp/SocietyRegistrations'];
        const inputId = formData.userId.trim();
        for (const node of registryNodes) {
            const registrySnapshot = await get(ref(db, node));
            if (registrySnapshot.exists()) {
                const registrants = registrySnapshot.val();
                const foundEntry = Object.entries(registrants).find(([key, u]) => 
                    (u.userName === inputId || u.email === inputId || u.whatsappNo === inputId || u.chairmanWhatsapp === inputId) && 
                    u.password === formData.password && u.password !== ''
                );
                if (foundEntry) {
                    const [key, userData] = foundEntry;
                    return { ...userData, _key: key, _node: node };
                }
            }
        }
        return null;
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            // First try Registry Login (Custom Username/Password/Mobile)
            const registryUser = await checkRegistries();
            if (registryUser) {
                toast.success(`स्वागत आहे, ${registryUser.firstName || registryUser.societyName || registryUser.surname}!`);
                
                // Store registry user session for consistent document pathing
                localStorage.setItem('currentUser', JSON.stringify({
                    ...registryUser,
                    _key: registryUser._key,
                    _node: registryUser._node,
                    role: registryUser._node.includes('Engineer') ? 'Engineer' : 'Society'
                }));
                
                navigate('/subhe-dashboard');
                setLoading(false);
                return;
            }

            // Fallback: Try Firebase Auth (for Officers/Admins with email)
            const inputId = formData.userId.trim();
            if (inputId.includes('@')) {
                try {
                    const userCredential = await signInWithEmailAndPassword(auth, inputId, formData.password);
                    const user = userCredential.user;
                    // user.displayName corresponds to the name stored during registration
                    const userNameKey = user.displayName || user.uid;
                    const snapshot = await get(ref(db, 'ekamwatapzp/users/' + userNameKey));
                    if (snapshot.exists()) {
                        const userData = snapshot.val();
                        toast.success(`स्वागत आहे, ${userData.name}!`);
                        
                        // Store Auth user session for consistent document pathing
                        localStorage.setItem('currentUser', JSON.stringify({
                            ...userData,
                            _key: userNameKey,
                            _node: 'ekamwatapzp/users',
                            role: userData.role
                        }));

                        let dashboardRoute = `/${userData.role.toLowerCase()}-dashboard`;
                        if (userData.role === 'Admin') dashboardRoute = '/admin-dashboard';
                        if (userData.role === 'CEO') dashboardRoute = '/ceo-dashboard';
                        if (userData.role === 'ZP Head') dashboardRoute = '/zp-head';
                        if (userData.role === 'Audit') dashboardRoute = '/audit/dashboard';
                        if (userData.role === 'Accountant') dashboardRoute = '/accountant-dashboard';
                        if (userData.role === 'Incharge') dashboardRoute = '/incharge-dashboard';
                        if (userData.role === 'User') dashboardRoute = '/subhe-dashboard';
                        
                        navigate(dashboardRoute);
                    } else {
                        toast.error("वापरकर्ता माहिती सापडली नाही.");
                    }
                } catch (authError) {
                    toast.error("लॉगिन अयशस्वी झाले. कृपया ईमेल/पासवर्ड तपासा.");
                }
            } else {
                toast.error("वापरकर्ता सापडला नाही किंवा चुकीचा पासवर्ड.");
            }
        } catch (error) {
            toast.error("लॉगिन करताना त्रुटी आली.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div 
            className="min-h-screen flex items-center justify-center p-4 relative bg-cover bg-center bg-no-repeat"
            style={{ 
                backgroundImage: `linear-gradient(rgba(240, 242, 245, 0.85), rgba(240, 242, 245, 0.85)), url(${slider3})`,
                backgroundColor: '#f0f2f5'
            }}
        >
            <ToastContainer position="top-right" autoClose={3000} />
            <div className="w-full max-w-md bg-white/10 backdrop-blur-[60px] border-2 border-white/50 rounded-3xl shadow-[0_0_40px_rgba(0,0,0,0.1)] overflow-hidden transform transition-all hover:scale-[1.01] relative z-10">
                <div className="p-8 text-center bg-white/5 border-b-2 border-white/20">
                    <div className="inline-flex items-center justify-center mb-4">
                        <img src={sangliLogo} alt="Sangli ZP Logo" className="h-28 w-auto drop-shadow-2xl brightness-110" />
                    </div>
                    <h2 className="text-3xl font-bold text-gray-800 mb-2">
                        {isRegistering ? 'खाते तयार करा' : 'स्वागत आहे'}
                    </h2>
                    <p className="text-gray-500 text-sm font-medium">
                        {isRegistering
                            ? 'एकंम वाटाप सांगली पोर्टलमध्ये सामील व्हा'
                            : 'तुमचा डॅशबोर्ड पाहण्यासाठी लॉगिन करा'}
                    </p>
                </div>

                <form onSubmit={isRegistering ? handleRegister : handleLogin} className="p-8 space-y-5">
                    {isRegistering && (
                        <div className="group relative">
                            <FaUser className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-blue-600 transition-colors" />
                            <input
                                type="text"
                                name="name"
                                placeholder="पूर्ण नाव (Full Name)"
                                required
                                className="w-full bg-white/10 border border-white/20 rounded-xl py-3.5 pl-12 pr-4 text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500/50 transition-all font-sans"
                                onChange={handleInputChange}
                                value={formData.name}
                            />
                        </div>
                    )}

                    <div className="group relative">
                        <FaUser className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-blue-600 transition-colors" />
                        <input
                            type="text"
                            name="userId"
                            placeholder={isRegistering ? "ईमेल पत्ता (Email Address)" : "युजरनेम / ईमेल / मोबाईल नंबर"}
                            required
                            className="w-full bg-white/10 border border-white/20 rounded-xl py-3.5 pl-12 pr-4 text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500/50 transition-all font-sans"
                            onChange={handleInputChange}
                            value={formData.userId}
                        />
                    </div>

                    <div className="group relative">
                        <FaLock className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-blue-600 transition-colors" />
                        <input
                            type="password"
                            name="password"
                            placeholder="पासवर्ड (Password)"
                            required
                            className="w-full bg-white/10 border border-white/20 rounded-xl py-3.5 pl-12 pr-4 text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500/50 transition-all font-sans"
                            onChange={handleInputChange}
                            value={formData.password}
                        />
                    </div>

                    {isRegistering && (
                        <div className="group relative">
                            <FaChevronDown className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-blue-600 transition-colors pointer-events-none" />
                            <select
                                name="role"
                                required
                                className="w-full bg-white/10 border border-white/20 rounded-xl py-3.5 pl-4 pr-10 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500/50 appearance-none transition-all font-sans"
                                onChange={handleInputChange}
                                value={formData.role}
                            >
                                <option value="" disabled className="bg-white text-gray-400">पद निवडा (Select Role)</option>
                                {roles.map((role) => (
                                    <option key={role} value={role} className="bg-white text-gray-700">
                                        {role}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 text-white font-bold py-4 rounded-xl shadow-lg shadow-blue-900/40 transform transition-all active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 group"
                    >
                        {loading ? (
                            <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                        ) : (
                            <>
                                {isRegistering ? 'नोंदणी करा (Register)' : 'लॉगिन करा (Login)'}
                                <FaSignInAlt className="group-hover:translate-x-1 transition-transform" />
                            </>
                        )}
                    </button>
                </form>

                {/* <div className="px-8 pb-8 text-center">
                    <div className="relative mb-8">
                        <div className="absolute inset-0 flex items-center">
                            <div className="w-full border-t border-gray-200"></div>
                        </div>
                        <div className="relative flex justify-center text-xs uppercase">
                            <span className="bg-white/10 px-2 text-gray-400 font-medium whitespace-nowrap">किंवा (Or)</span>
                        </div>
                    </div>

                    <p className="text-gray-500 text-sm">
                        {isRegistering ? 'आधीच खाते आहे?' : "खाते नाही?"}{' '}
                        <button
                            onClick={() => setIsRegistering(!isRegistering)}
                            className="text-blue-600 hover:text-blue-700 font-bold underline underline-offset-4 decoration-2 transition-colors focus:outline-none"
                        >
                            {isRegistering ? 'येथे लॉगिन करा' : 'आता नोंदणी करा'}
                        </button>
                    </p>
                </div> */}
            </div>
        </div>
    );
};

export default Login;
